import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import electionConfirmation from "../../../../src/content/cissie-digital-election-guide/electionConfirmation";
import "../../../../src/content/cissie-digital-election-guide/cissie-election-guide.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  electionConfirmation,
  React
};